// extracted by mini-css-extract-plugin
export var iconGood = "SkillStatusIcon-module--iconGood--SeoY1";
export var iconSoso = "SkillStatusIcon-module--iconSoso--Y34nF";